export default {
  'pages.importNotice.title': '重要信息',
  'pages.importNotice.subtitle': '管理和发布重要信息通知',
  'pages.importNotice.tab.enabled': '启用列表',
  'pages.importNotice.tab.disabled': '停用列表',
  'pages.importNotice.create': '新建通知',
  'pages.importNotice.edit': '编辑通知',
  'pages.importNotice.batchDelete': '批量删除',
  'pages.importNotice.confirmDelete': '确定要删除这个通知吗？',
  'pages.importNotice.confirmBatchDelete': '确定要删除选中的 {count} 个通知吗？',
  'pages.importNotice.deleteSuccess': '删除通知成功',
  'pages.importNotice.batchDeleteSuccess': '批量删除通知成功',
  'pages.importNotice.createSuccess': '创建通知成功',
  'pages.importNotice.updateSuccess': '更新通知成功',
  'pages.importNotice.deleteFailed': '删除通知失败',
  'pages.importNotice.batchDeleteFailed': '批量删除通知失败',
  'pages.importNotice.createFailed': '创建通知失败',
  'pages.importNotice.updateFailed': '更新通知失败',
  'pages.importNotice.getListFailed': '获取通知列表失败',
  'pages.importNotice.columns.title': '通知标题',
  'pages.importNotice.columns.content': '通知内容',
  'pages.importNotice.columns.priority': '优先级',
  'pages.importNotice.columns.status': '状态',
  'pages.importNotice.columns.startTime': '开始时间',
  'pages.importNotice.columns.endTime': '结束时间',
  'pages.importNotice.columns.createdBy': '创建人',
  'pages.importNotice.columns.createTime': '创建时间',
  'pages.importNotice.columns.operations': '操作',
  'pages.importNotice.actions.view': '查看',
  'pages.importNotice.actions.edit': '编辑',
  'pages.importNotice.actions.delete': '删除',
  'pages.importNotice.titleRequired': '请输入通知标题',
  'pages.importNotice.titlePlaceholder': '请输入通知标题',
  'pages.importNotice.contentRequired': '请输入通知内容',
  'pages.importNotice.contentPlaceholder': '请输入通知内容',
  'pages.importNotice.statusRequired': '请选择状态',
  'pages.importNotice.startTimePlaceholder': '请选择开始时间',
  'pages.importNotice.endTimePlaceholder': '请选择结束时间',
  'pages.importNotice.status.enabled': '启用',
  'pages.importNotice.status.disabled': '禁用',
  'pages.importNotice.priority.level1': '1级 - 低',
  'pages.importNotice.priority.level2': '2级 - 中低',
  'pages.importNotice.priority.level3': '3级 - 中',
  'pages.importNotice.priority.level4': '4级 - 中高',
  'pages.importNotice.priority.level5': '5级 - 高',
  'pages.importNotice.detail.title': '通知详情',
  'pages.importNotice.detail.content': '通知内容',
};
